export class CurrentPageStateModel {
  page: string | undefined;
  appInit: boolean | undefined;
  loginReturnLink?: string;
}
